var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Query } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { UserStore } from './user.store';
var UserQuery = /** @class */ (function (_super) {
    __extends(UserQuery, _super);
    function UserQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        return _this;
    }
    UserQuery.prototype.isLoading = function () {
        return this.select(function (state) { return state.loading; });
    };
    UserQuery.prototype.getUserSnapshot = function () {
        return this.getValue().user;
    };
    UserQuery.prototype.getUser = function () {
        return this.select(function (state) { return state.user; });
    };
    UserQuery.prototype.userHasPlcCard = function () {
        return this
            .select(function (state) { return state.user; })
            .pipe(map(function (user) { return user ? user.containsPlcCard : false; }));
    };
    return UserQuery;
}(Query));
export { UserQuery };
